export default __webpack_public_path__ + "static/media/usd-coin.c6c61da1.svg";